import { StatusProjetoEnum } from "@/core/enums/projetos";

const stripHtml = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '').trim();
};

export const isStrictProject = (projeto) => {
    return [
        StatusProjetoEnum.REVISAO_GALAPOS,
        StatusProjetoEnum.VALIDACAO_FINAL_GALAPOS,
        StatusProjetoEnum.APROVADO_SUBMISSAO,
        StatusProjetoEnum.SUBMETIDO
    ].includes(projeto.status);
};

export const validateField = (value, rules, isStrict) => {
    if (!rules || !rules.length) return true;

    for (const ruleObj of rules) {
        const { rule, params } = ruleObj;

        if (rule === "required") {
            if (!isStrict) continue;
            if (value === null || value === undefined || value === "") return false;
            if (Array.isArray(value) && value.length === 0) return false;
        }

        if (rule === "max" && value) {
            const textLength = typeof value === 'string' ? stripHtml(value).length : value.length;
            if (textLength > params.size) return false;
        }

        if (rule === "min" && value) {
            const textLength = typeof value === 'string' ? stripHtml(value).length : value.length;
            if (textLength < params.size) return false;
        }
    }

    return true;
};

export const getProjectErrors = (project, fields, isStrict) => {
    let errors = 0;
    for (const field of fields) {
        if (field.condition && !field.condition(project)) continue;
        const value = project[field.key];
        if (!validateField(value, field.rules, isStrict)) {
            console.log('[tabErrors] campo com erro:', field.key);
            errors++;
        }
    }
    return errors;
};
